import React from 'react';
import { Pressable, Text, View } from 'react-native';
import InventoryPanel from './InventoryPanel';
import SheetHeader from '../../../components/Reusables/bottomSheet/SheetHeader';
import type { InventoryStyles } from './inventoryStyles';
import {
  DEFAULT_INVENTORY_SORT,
  SORT_OPTIONS,
  type InventorySort,
} from '../../../utils/inventoryFilters';

type Props = {
  styles: InventoryStyles;
  theme: any;
  open: boolean;
  sort: InventorySort;
  onSelect: (sort: InventorySort) => void;
  onClose: () => void;
};

/** One radio row per sort option; picking one applies it and closes the sheet. */
const InventorySortSheet: React.FC<Props> = ({
  styles,
  theme,
  open,
  sort,
  onSelect,
  onClose,
}) => (
  <InventoryPanel
    styles={styles}
    open={open}
    onClose={onClose}
    snapPoints={['62%']}
    header={
      <SheetHeader title="Sort by" onClose={onClose} />
    }>
    <View>
      {SORT_OPTIONS.map(option => {
        const selected = option.key === sort;
        return (
          <Pressable
            key={option.key}
            onPress={() => {
              onSelect(option.key);
              onClose();
            }}
            accessibilityRole="radio"
            accessibilityState={{ checked: selected }}
            style={({ pressed }) => [
              styles.optionRow,
              pressed && styles.buttonPressed,
            ]}>
            <Text
              style={[
                styles.optionLabel,
                selected && styles.optionLabelSelected,
              ]}>
              {option.label}
              {option.key === DEFAULT_INVENTORY_SORT ? (
                <Text style={styles.optionTag}>{'   Default'}</Text>
              ) : null}
            </Text>
            <View style={[styles.radio, selected && styles.radioSelected]}>
              {selected ? <View style={styles.radioDot} /> : null}
            </View>
          </Pressable>
        );
      })}
    </View>
  </InventoryPanel>
);

export default InventorySortSheet;
